import { Component, OnInit } from '@angular/core';
import { ApiService } from '../api.service';
import { AuthService } from '../auth.service';
import { HandlerService } from '../handler.service';
import { AppComponent } from '../app.component';
import { Router } from '@angular/router';

@Component({
  selector: 'app-approvalorg-details',
  templateUrl: './approvalorg-details.component.html',
  styleUrls: ['./approvalorg-details.component.scss'],
})
export class ApprovalorgDetailsComponent {
url;
id;
orgdetail;
name;
mob;
category;
website;
email;
loader: boolean = false;
confirm:boolean;
rej:boolean;
  constructor(public service: ApiService,
    public router: Router,
    public handler: HandlerService,
    public auth: AuthService,
    public app: AppComponent,) { }


     ionViewWillEnter(){
      this.url = window.location.href;
      this.id = this.url.split('/').pop();
      this.getOrg();
     }

     getOrg(){
       this.loader = true;  
       this.service.getOrgById(this.id).subscribe(res=>{
       this.orgdetail = res;
       this.name = this.orgdetail.name
       this.mob = this.orgdetail.contactNbrMob.slice(3)
       this.website = this.orgdetail.website
       this.email = this.orgdetail.emailId
       this.loader = false; 
     },err=>{
       this.handler.err(err);
       this.loader = false;
     })
   }
   

   approval(){
    this.service.orgApproval(this.id).subscribe(res=>{
      this.confirm=false;
     this.router.navigate(['/vendor-approval']);
    })
  }
 
  reject(){
    this.service.orgReject(this.id).subscribe(res=>{
      this.rej=false;
      this.router.navigate(['/vendor-approval']);
     })
   }
 
}
